<template>
  <generic-modal
    @close="closeSearchModal($event, '')"
    :height="searchModalDim.height"
    :width="searchModalDim.width"
    :modalClass="searchModalDim.modalClass"
    :contentScroll="false"
    :dependentComputedProps="{
      showProductCardInModalFor,
    }"
  >
    <template v-slot:header> </template>
    <template v-slot:body>
      <div :class="[clientPlatform == 'Web' ? 'ete-wrap' : '']">
        <div
          :class="[
            clientPlatform == 'Web' ? 'container-desktop' : 'container-pwa',
          ]"
        >
          <div class="search-modal-input-container">
            <!-- <i @click="closeSearchModal($event, 'cross')" class="jfi-back-v2 search-back"
              >&#8249;</i
            > -->
            <img
              v-on:click="closeSearchModal($event, 'cross')"
              :src="staticImgBaseUrl + '/images/global/back-arrow.svg'"
              alt="location-pin"
            />
            <input
              class="search-query-input medium fs-14"
              id="searchQueryInputModal"
              type="text"
              name="searchQueryInputModal"
              :placeholder="this.modulePropsParsed?.placeHolder"
              v-model="searchText"
              @input="activeDebounce($event.target.value)"
            />
            <img
              @click="clearSearchModal()"
              class="search-cross color-black fs-xlg"
              v-if="searchText.length > 0"
              :src="staticImgBaseUrl + '/images/global/clear-icon.svg'"
              alt="location-pin"
            />
            <i v-if="searchText.length == 0" class="hkfi-search-lens"></i>
          </div>
        </div>
      </div>
      <div :class="[clientPlatform == 'Web' ? 'container-desktop' : '']">
        <div
          class="no-result no-result-search"
          v-if="
            Object.keys(productSearchResults).length === 0 &&
            !isPopularSearchToggle
          "
        >
          <i class="hkfi-logo-hongs"></i>
          <div class="no-result-title fs-16 bold">
            {{ modulePropsParsed?.emptySearchTitle }}
          </div>
          <div class="no-result-content fs-14">
            {{ modulePropsParsed?.emptySearchSubTitle }}
          </div>
        </div>
      </div>
      <div
        :class="[
          clientPlatform == 'Web' ? 'lg-cards-wrapper container-desktop' : '',
          isPopularSearchToggle ? '' : 'mb100',
        ]"
      >
        <hongs-product-card
          v-for="(value, key, index) in productSearchResults"
          :key="key"
          :data-item="value"
          :data-smallCards="true"
          :data-item-index="index"
          :showFullInfo="true"
          :searchText="searchText"
        ></hongs-product-card>
      </div>
      <div
        class="plr16"
        :class="[
          clientPlatform == 'Web' ? 'lg-cards-wrapper container-desktop' : '',
        ]"
        v-if="
          Object.keys(productSearchResults).length === 0 &&
          isPopularSearchToggle
        "
      >
        <div class="fs-12 popular-search bold mt8 mb15">
          {{ modulePropsParsed?.title }}
        </div>
        <div
          v-for="(item, ind) in modulePropsParsed?.popularSearch?.split(',') ||
          []"
          :key="ind"
          :class="[
            'color-base pb12 pt10 cursor-pointer',
            ind !==
              (modulePropsParsed?.popularSearch?.split(',') || []).length - 1 &&
              'border-bottom-light',
          ]"
          @click="popularItemFun(item, ind)"
        >
          <i class="hkfi-clock mr5"></i>
          {{ item }}
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div><bottom-bar></bottom-bar></div>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import InlineNotification from "./InlineNotification.vue";
import HongsProductCard from "./HongsProductCard.vue";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import debounce from "lodash/debounce";
import Utility from "../helpers/utility";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import {
  EVENT_PAGEVIEW_SEARCHPAGE,
  EVENT_TYPE_SEARCHINPUT,
  EVENT_IMPRESSION_SEARCHRESULT,
  EVENT_CLICK_SEARCHOPTION,
  loadAmplitudeUnsentEvents,
} from "../helpers/analyticsEvents";
import { initializeMetaTime } from "../helpers/metaEvents";
import PageNames from "../config/pageNames";

export default {
  name: "SearchModal",
  components: {
    GenericModal,
    InlineNotification,
    HongsProductCard,
  },
  props: ["moduleProps"],
  data() {
    return {
      searchModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup search-modal-wrap",
      },
      // downArrow,
      searchText: "",
      productSearchResults: {},
      isPopularSearchToggle: true,
      staticImgBaseUrl,
      modulePropsParsed: {},
      shouldProcessEventTypeSearchInput: false,
      clientPlatform,
    };
  },
  async mounted() {
    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    loadAmplitudeUnsentEvents(PageNames.HONGS_SEARCH_PAGE);
    setTimeout(() => {
      initializeMetaTime();
    }, 5000);
    //userActivityTracking.pageView(0,"searchPageViewed");
    this.modulePropsParsed = JSON.parse(this.moduleProps);
    // document.body.classList.add("body-stop-scroll-mobile");
    EVENT_PAGEVIEW_SEARCHPAGE();
  },
  methods: {
    closeSearchModal(e, source) {
      e.stopPropagation();
      this.clearSearchModal();
      // this.$store.commit(keyMapsMutation.UPDATE_SHOW_SEARCH_MODAL, false);
      // document.body.classList.remove("body-stop-scroll-mobile");
      this.$emit("close");
      Utility.appBackButtonFunc();
      window.history.back();
    },
    activeDebounce: debounce(function (text) {
      /*       if (Utility.getSearchableText(text).length <= 2) {
        return;
      } */
      if (this.shouldProcessEventTypeSearchInput) {
        EVENT_TYPE_SEARCHINPUT();
        this.shouldProcessEventTypeSearchInput = false;
      }
      if (text.length > 2) {
        this.searchItem(text);
        this.isPopularSearchToggle = false;
      } else if (text.length == 0) {
        this.isPopularSearchToggle = true;
        this.productSearchResults = {};
      }
    }, 500),
    clearSearchModal() {
      this.searchText = "";
      this.productSearchResults = {};
      this.isPopularSearchToggle = true;
    },
    searchItem(text) {
      this.productSearchResults =
        this.$store.getters[keyMapsGetter.PRODUCT_SEARCH_RESULTS](text);
      if (Object.keys(this.productSearchResults).length > 0) {
        EVENT_IMPRESSION_SEARCHRESULT();
      }
    },
    popularItemFun(data, index) {
      this.isPopularSearchToggle = false;
      this.searchText = data || "";
      this.searchItem(data);
      EVENT_CLICK_SEARCHOPTION({ positionWithinSection: index + 1 });
    },
  },
  computed: {
    // showSearchModal() {
    //   let _ = this.$store.state.ProductItems.showSearchModal;
    //   if (_) {
    //     // this.productSearchResults =
    //     //   this.$store.getters[keyMapsGetter.PRODUCT_SEARCH_RESULTS]();

    //     this.shouldProcessEventTypeSearchInput = true;
    //   }
    //   return _;
    // },
    showProductCardInModalFor() {
      let showProductCardInModal =
        this.$store.state.ProductItems.showProductCardInModalFor;
      if (Object.keys(showProductCardInModal).length > 0) {
        setTimeout(() => {
          typeof searchQueryInputModal === "undefined"
            ? ""
            : searchQueryInputModal.blur();
        }, 0);
      }
      return showProductCardInModal;
    },
  },
};
</script>

<style></style>
